import React, { useState, useEffect } from 'react'
import styles from './MeningitisIndices.module.scss'
// import styles from './MapPage.module.scss'
import DropDownList from '../../components/DropDownList'
import { useGeoFetch, useGeoState } from '../../components/GeoProvider'
import Button from '../../components/Button'
import Filters from './Filters'
import SelectList from '../../components/SelectMenuList'
import DefaultBreadcrumbs from '../../components/Breadcrumbs/DefaultBreadcrumbs'
import typeDisplayOptions from '../Dashboard/typeDisplayOptions'
import DataCards from '../../components/DataCards'
import HeaderDataStats from './HeaderDataStats'

const Header = ({ headerType, headerNumber }) => {
   
  return (
    <>
 <div className={styles.pageHeader}>
  <div className={styles.pageHeaderText}>
          <DefaultBreadcrumbs
            geo_id={'NAT'}
            geo_type={'NAT'}
            dashboardType={'RSV'}
          />
          <SelectList
            dropdownData={typeDisplayOptions}
            defaultValue={'meningitis'}
            defaultLabel={'Meningitis Dashboard'}
          />
          <p style={{marginTop:'-20px', color:'#e40046',fontSize:'16px'}}>&nbsp; <b>(Proof of concept)</b></p>
        </div>
    <div className={styles.pageHeaderTextValue}>
      <Filters/>
      
    </div>
 
 </div>
      <HeaderDataStats/>
    </>
)}
export default Header
